import { PaginationContext } from "context/PaginationContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const usePagination = () =>
  useProviderInitializedContext(PaginationContext);
